import {productContentBlockSettings, ProductContentBlockSettings} from '@/bps/components/productContentBlock/productContentBlockSettings';

productContentBlockSettings.readMoreHeight = 230;

export {productContentBlockSettings, ProductContentBlockSettings};
